<section class="main">
  <h1>Utilities</h1>
  <section>
    <button class="btn mb-2" (click)="addUilty()">Add Utilty</button>
    <div class="row">
      <div class="col-md-4">
        <section class="menuItems">
          <div class="box" (click)="uilty_details(item)"
            [ngClass]="{'active': item.status == true , 'justify-content-between' : item.status == true }"
            *ngFor="let item of allUitlty">
            <img src="{{item.image}}" style="width: 60px ; height: 60px;">
            <p>{{ item.name }}</p>
            <img *ngIf="item.status == true" (click)="addUilty(item)" class="edit me-2" src="assets/images/edit-64.png">
          </div>
        </section>
      </div>
      <div class="col-md-8">
        <section class="menuItems">
          <div class="headMicro d-flex justify-content-between align-items-center">
            <h1>Unit measure : {{ uiltyDetails.unit_measure }}</h1>
            <div>
              <button class="btn mb-2" (click)="addSection(uiltyDetails , 'add')">Add Section</button>
              <button class="btn mb-2 ms-2" (click)="addInvoce()">Add Invoice</button>
            </div>
          </div>
          <hr />

          <table class="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Price</th>
                <th scope="col">Start</th>
                <th scope="col">End</th>
                <th scope="col">Created at</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of uiltyDetails.sections">
                <td>{{item.name}}</td>
                <td>{{item.price}}</td>
                <td>{{item.start}}</td>
                <td>{{item.end}}</td>
                <td>{{item.created_at}}</td>
                <td>
                  <img style="width: 20px ; cursor: pointer;" (click)="addSection(item , 'edit')" class="edit me-2"
                    src="assets/images/edit-64.png">
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>
  </section>

</section>